import { useEffect, useRef, useState } from "react";

const STEPS = [
  ["Take the journey", "Five stops, about 40 to 60 minutes. Pause anytime and pick up right where you left off."],
  ["Get your report", "Read it on screen, save it as a PDF and find it in your email."],
  ["Talk it through together", "Share what surprised you and what felt right, with a career counsellor too if you'd like."],
];

export default function HowItFeels() {
  const ref = useRef(null);
  const [drawn, setDrawn] = useState(false);
  useEffect(() => {
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setDrawn(true), { threshold: 0.35 });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  return (
    <section id="how" className="ds-section bg-ds-cream" data-testid="landing-how-it-feels">
      <div className="container-x">
        <h2 className="ds-h2 max-w-2xl" data-reveal>Less like an exam. More like a walk with a friend.</h2>
        <div ref={ref} className="relative mt-14">
          <svg className="hidden md:block absolute inset-x-0 top-0 w-full h-[120px]" viewBox="0 0 1200 120" preserveAspectRatio="none" fill="none" aria-hidden="true">
            <defs><clipPath id="route-clip"><rect className="route-draw" x="0" y="0" height="120" width={drawn ? 1200 : 0} style={{ transition: "width 1.4s ease-out" }} /></clipPath></defs>
            <path d="M40 60 C 220 -10, 380 130, 600 60 S 980 -10, 1160 60" stroke="#4F0341" strokeOpacity="0.35" strokeWidth="2.5" strokeDasharray="2 10" strokeLinecap="round" clipPath="url(#route-clip)" />
          </svg>
          <ol className="relative grid md:grid-cols-3 gap-10 md:gap-8 md:pt-[34px]">
            <span className="md:hidden absolute left-[19px] top-2 bottom-2 border-l-2 border-dotted border-ds-plum/35" aria-hidden="true" />
            {STEPS.map(([title, text], i) => (
              <li key={title} className={`relative pl-14 md:pl-0 ${i === 1 ? "md:pt-10" : ""}`} data-testid={`how-step-${i + 1}`}>
                <span className="absolute left-0 md:static flex h-10 w-10 items-center justify-center rounded-full bg-ds-plum font-display text-lg font-semibold text-white ring-[6px] ring-ds-cream">{i + 1}</span>
                <h3 className="md:mt-5 font-display text-2xl font-semibold text-ds-plumdeep">{title}</h3>
                <p className="mt-2 text-[16px] text-ds-inksoft leading-relaxed max-w-sm">{text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
